import { Content_Block } from "../ContentBlock";

export class IframeBlock extends Content_Block{
    constructor(){
        super("iframe");
        this.code = "";    
    }
}